import {
  AppName,
  FileDBValue,
  PopulatedThreadMessage,
  SendThreadMessageReply,
  ThreadType,
} from '@hb/shared'
import {
  deleteMessageFunction,
  editMessageFunction,
  markThreadReadStatusFunction,
  reportMessageReadFunction,
  reportThreadReadFunction,
  sendMessageFunction,
  toggleThreadMuteFunction,
  updateWebPushNotificationSettings,
} from '../../backend/functions/other'
import { messaging, VAPID_KEY } from '../../backend/messaging'
import { getHBDeviceId } from '../../utils'
import { assertPushNotificationToken } from '../../utils/pushNotifications'

export const sendThreadMessage = async (
  appName: AppName,
  threadType: ThreadType,
  threadId: string,
  message: string,
  replyTo: SendThreadMessageReply | null = null,
  attachedFiles: Record<string, FileDBValue> = {},
) => {
  const { data } = await sendMessageFunction({
    threadId,
    type: threadType,
    message,
    appName,
    replyTo,
    attachedFiles,
  })
  return data
}

export const deleteThreadMessage = async (message: PopulatedThreadMessage) => {
  const { messageGroupId, threadId, createdOn, threadType } = message ?? {}
  // batch.update(threadMessageGroupRef, `messages.${createdOn}.deletedOn`, Date.now())
  // batch.update(threadMessageGroupRef, `messages.${createdOn}.deletedBy`, uid)
  const { data } = await deleteMessageFunction({
    type: threadType,
    messageId: `${createdOn}`,
    threadId,
    messageGroupId,
  })

  return data
}

export const editThreadMessage = async (message: PopulatedThreadMessage, newMessage: string) => {
  const { messageGroupId, threadId, createdOn, threadType } = message ?? {}
  const { data } = await editMessageFunction({
    type: threadType,
    messageId: `${createdOn}`,
    threadId,
    messageGroupId,
    newMessage,
  })

  return data
}

export const reportThreadRead = async (appName: AppName, type: ThreadType, threadId: string) => {
  const { data } = await reportThreadReadFunction({
    threadId,
    type,
    appName,
  })

  return data
}

export const reportMessageRead = async (message: PopulatedThreadMessage) => {
  const { messageGroupId, threadId, threadType, createdOn: messageId, editedOn } = message ?? {}

  if (!messageId || (messageId as any) === 'undefined') return

  const { data } = await reportMessageReadFunction({
    type: threadType,
    messageId: `${messageId}`,
    threadId,
    messageGroupId,
    editedOn,
  })

  return data
}

export const markThreadReadStatus = async (
  appName: AppName,
  type: ThreadType,
  threadId: string,
  isRead: boolean,
) => {
  const { data } = await markThreadReadStatusFunction({
    threadId,
    type,
    appName,
    isRead,
  })

  return data
}

export const toggleThreadMute = async (type: ThreadType, threadId: string, mute: boolean) => {
  const { data } = await toggleThreadMuteFunction({ type, threadId, mute })
  return data
}

export const enableMessagingWebPushNotifications = async () => {
  const hasPushNotifications = await assertPushNotificationToken(
    messaging,
    VAPID_KEY,
    getHBDeviceId(),
  )
  if (!hasPushNotifications) {
    throw new Error('User denied push notifications')
  }
  await updateWebPushNotificationSettings({ topic: 'messaging', enabled: true })
}

export const disableMessagingWebPushNotifications = async () => {
  await updateWebPushNotificationSettings({
    topic: 'messaging',
    enabled: false,
  })
}
